import React, { Component, Fragment } from 'react';
import Text from '../../react-component/textComponent';
import Colors from '../../config/Colors';
import ReactModal from 'react-modal';
import { View } from 'react-native';
import Switch from 'react-switch';
import styles from './styles';
import { Close } from '@mui/icons-material';

class ModalDisponibilidadeLoja extends Component {
    state = {
        isOpen: false
    };

    componentDidMount() {
        this.setState({ isOpen: true });
    }

    getParent = () => {
        return document.querySelector('#ReactModalPortal');
    };

    closeModal = () => {
        if (!this.props.isSaveButtonLoading) {
            this.props.onClose();
        }
    };

    render() {
        const { isDisponivel, nomeLoja, onChange, isMobile } = this.props,
            { isOpen } = this.state;

        return (
            <Fragment>
                {isMobile ? (
                    <ReactModal
                        {...this.props}
                        ariaHideApp={false}
                        isOpen={isOpen}
                        onRequestClose={this.closeModal}
                        parentSelector={this.getParent}
                        style={styles.modalDispMobile}
                    >
                        <div style={styles.modalHeader}>
                            <View style={styles.modalContent}>
                                <View style={styles.titleLine}>
                                    <Text $bold style={styles.pageTitle}>
                                        {nomeLoja}
                                    </Text>

                                    <button
                                        onClick={this.closeModal}
                                        style={{
                                            width: 25,
                                            height: 25,
                                            cursor: 'pointer',
                                            backgroundColor: Colors.regular,
                                            borderRadius: 100,
                                            borderWidth: 1,
                                            borderStyle: 'solid',
                                            borderColor: Colors.border,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: 2
                                        }}
                                    >
                                        <Close
                                            sx={{
                                                fontSize: 18,
                                                color: Colors.white
                                            }}
                                        />
                                    </button>
                                </View>

                                <View>
                                    <View style={styles.dispContainer}>
                                        <View style={styles.switch}>
                                            <Switch
                                                onChange={onChange}
                                                checked={isDisponivel}
                                                height={16}
                                                width={32}
                                                activeBoxShadow=""
                                            />
                                        </View>
                                        <Text style={styles.dispText}>
                                            {isDisponivel
                                                ? 'Disponível'
                                                : 'Indisponível'}
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </div>
                    </ReactModal>
                ) : (
                    <ReactModal
                        {...this.props}
                        ariaHideApp={false}
                        isOpen={isOpen}
                        onRequestClose={this.closeModal}
                        parentSelector={this.getParent}
                        style={styles.modalDisp}
                    >
                        <div style={styles.modalHeader}>
                            <View>
                                <Text $bold style={styles.pageTitle}>
                                    {nomeLoja}
                                </Text>

                                <View style={styles.dispContainer}>
                                    <View style={styles.switch}>
                                        <Switch
                                            onChange={onChange}
                                            checked={isDisponivel}
                                            height={16}
                                            width={32}
                                            activeBoxShadow=""
                                        />
                                    </View>
                                    <Text style={styles.dispText}>
                                        {isDisponivel
                                            ? 'Disponível'
                                            : 'Indisponível'}
                                    </Text>
                                </View>
                            </View>
                        </div>
                    </ReactModal>
                )}
            </Fragment>
        );
    }
}

export default ModalDisponibilidadeLoja;
